// src/com/auto_cpp_info/AutoCppInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_CPP_INFO Apollo Graphql
 * DC별 일일 물동량 볼륨
 * Project: NewTOP for cloud
 * 2024-11-01 17:02:01 using DbdbTap.
 ************************************************ */

const AUTO_CPP_INFO_LIST_PART = gql`
fragment AutoCppInfoListPart on AutoCppInfo {
    dcCd
    planDate
    dayTotVol
    cppTot
    tpc
    fillRate
    leftOver
    processStep
    vehTotCnt
    updateDate
    regDate
    regUser
    dcName
    tpcTarget
    regUserName
}
`; // tpcTarget은 2019.2월 이후 사용하지 않고 있음.


// 조회 월을 나타내는 yyyy-mm-01 형식의 문자열
export const LIST_AUTO_CPP_INFO = gql`
${AUTO_CPP_INFO_LIST_PART}
query ListAutoCppInfo($planDate:String!) {
    autoCppInfoList(planDate:$planDate) {
        ...AutoCppInfoListPart
    }
}
`;

export const GET_AUTO_CPP_INFO = gql`
${AUTO_CPP_INFO_LIST_PART}
query GetAutoCppInfo($dcCd:String!, $planDate:String!) {
    autoCppInfoItem(dcCd:$dcCd, planDate:$planDate) {
        ...AutoCppInfoListPart
    }
}
`;

export const ADD_AUTO_CPP_INFO = gql`
mutation AddAutoCppInfo($autoCppInfo:InputAutoCppInfoAdd!) {
	autoCppInfoAdd(autoCppInfo: $autoCppInfo) {
		ok
		message
	}
}
`;

export const EDIT_AUTO_CPP_INFO = gql`
mutation EditAutoCppInfo($autoCppInfo:InputAutoCppInfoEdit!) {
	autoCppInfoEdit(autoCppInfo: $autoCppInfo) {
		ok
		message
	}
}
`;

export const REMOVE_AUTO_CPP_INFO = gql`
mutation RemoveAutoCppInfo($autoCppInfo:InputAutoCppInfoRemove!) {
	autoCppInfoRemove(autoCppInfo: $autoCppInfo) {
		ok
		message
	}
}
`;

// autoCppInfoStateHeaderItem(planDate:String!): AutoCppInfo
export const GET_AUTO_CPP_INFO_STATE_HEADER = gql`
query GetAutoCppInfoStateHeader($planDate:String!) {
    autoCppInfoStateHeaderItem(planDate:$planDate) {
        dcName
        dcCd
        dayTotVol
        cppTot
        tpc
        fillRate
        leftOver
        processStep
        vehTotCnt
        updateDate
        regDate
        tpcTarget
    }
}
`;

/*

    autoCppInfoStepUp(autoCppInfo: InputAutoCppInfoPlanDate!): CommonResponse!

input InputAutoCppInfoPlanDate {
	planDate: String!
}

*/

export const STEP_UP_AUTO_CPP_INFO = gql`
mutation StepUpAutoCppInfo($autoCppInfo: InputAutoCppInfoPlanDate!) {
    autoCppInfoStepUp(autoCppInfo: $autoCppInfo) {
        ok
        message
    }
}
`;
